import React from 'react';

import AdminLayout from '../../components/AdminLayout';
import Promotions from './Promotions';


const PromotionsPage = () => {
    return (
        <AdminLayout>
            <Promotions />
        </AdminLayout>
    );
};

export default PromotionsPage;